import React, { useState } from "react";
import styles from "./swap-button.module.scss";
import ArrowLeft from "@/components/svg/arrowLeft";
import ArrowRight from "@/components/svg/arrowRight";
import classNames from "classnames";
import { useBridge } from "@/features/bridge/providers/bridge.provider";

const SwapButton = () => {
  const [swapping, setSwapping] = useState(false);

  const {
    bridgeControls: { swapChains, fromChain, toChain },
  } = useBridge();

  const handleSwap = () => {
    setSwapping(true);
    setTimeout(() => {
      setSwapping(false);
    }, 200);
    swapChains();
  };

  return (
    <button
      className={styles.swapButton}
      onClick={handleSwap}
      disabled={
        !fromChain.originChain && !toChain.destinationChain ? true : false
      }
    >
      <div className={styles.arrowWrapper}>
        <ArrowRight
          className={classNames(
            styles.arrow,
            swapping && styles.rightAnimating,
          )}
        />
        <ArrowLeft
          className={classNames(styles.arrow, swapping && styles.leftAnimating)}
        />
      </div>
    </button>
  );
};

export default SwapButton;
